import instance from "../../../config/axios";
import url from "../../../constants/url";

const certification = "certification";
const grid = "grid-list";

//api call for certification list
export const getCertificationListApi = async (payload) => {
  return instance
    .post(`${url.packagingapiurl}${certification}/${grid}`, payload)
    .then((res) => {
      return res;
    });
};